import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatItemDisplay } from '../../models/ChatItemDisplay';
import { AuthService } from '../../services/auth.service';
import { ChatbotService } from '../../services/chatbot.service';
import { firstValueFrom } from 'rxjs';
import { User } from '../../models/User';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';
import { MarkdownPipe } from '../../pipes/markdown.pipe';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'chatbotv2',
  standalone: true,
  imports: [FormsModule, TranslateModule, MarkdownPipe, LottieComponent],
  templateUrl: './chatbotv2.component.html',
  styleUrl: './chatbotv2.component.scss',
})
export class Chatbotv2Component {
  @Input() shouldShow = false;
  @Output() shouldShowChange = new EventEmitter<boolean>();
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  user?: User;
  inputMessage = '';
  messages: ChatItemDisplay[] = [new ChatItemDisplay(this.translationService.instant('chatbot.introductionMessage'), undefined)];
  avatarAnimationOptions: AnimationOptions | null = {
    loop: false,
    autoplay: false,
  };

  constructor(
    private authService: AuthService,
    private chatbotService: ChatbotService,
    private translationService: TranslationService,
  ) {}

  async ngOnInit() {
    const user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());

    this.user = user;
    this.avatarAnimationOptions = {
      ...this.avatarAnimationOptions,
      path: `assets/lottie/avatars/${this.user.avatar_id ?? 1}.json`,
    };
  }

  close() {
    this.shouldShow = false;
    this.shouldShowChange.emit(this.shouldShow);
  }

  async sendMessage() {
    if (this.inputMessage === '') {
      return;
    }

    const message = this.inputMessage;
    const element = this.scrollContainer.nativeElement;
    this.messages.push(new ChatItemDisplay(undefined, this.inputMessage));
    setTimeout(() => {
      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'smooth',
      });
    }, 100);
    this.inputMessage = '';
    this.messages.push(new ChatItemDisplay('...', undefined));

    for await (const chunk of this.chatbotService.askQuestion(message)) {
      if (this.messages[this.messages.length - 1].chatbotResponse === '...') {
        this.messages[this.messages.length - 1].chatbotResponse = '';
      }

      this.messages[this.messages.length - 1].chatbotResponse += chunk;
      setTimeout(() => {
        element.scrollTo({
          top: element.scrollHeight,
          behavior: 'smooth',
        });
      }, 100);
    }
  }

  getBackgroundColorForAvatar(): string {
    let avatar: number = 0;
    if (this.user?.avatar_id !== undefined) {
      avatar = parseInt(this.user.avatar_id) - 1;
    }
    const array = ['#5a36b2', '#007eff', '#3abcd8', '#ec407a', '#0fc461', '#ee8b60', '#f4b60b'];

    return array[avatar % array.length];
  }

  onError(event: any) {
    console.error('Lottie error:', event);
  }
}
